import { useMemo } from 'react';
import { FirebaseError } from 'firebase/app';
import { useMutation } from '@tanstack/react-query';
import type { PrestigeConfigurationData } from '@core';
import { repositoryHost } from '@repositories';
import { serviceHost } from '@services';

const isNotFoundError = (error: unknown): boolean =>
  error instanceof FirebaseError && error.code === 'not-found';

export const useSavePrestigeConfiguration = (configId: string | undefined) => {
  const repository = useMemo(
    () =>
      repositoryHost.getPrestigeConfigurationRepository(
        serviceHost.getDatabaseService(),
      ),
    [],
  );

  const mutation = useMutation({
    mutationFn: async (configuration: PrestigeConfigurationData) => {
      if (!configId) {
        throw new Error('Missing config ID');
      }

      try {
        await repository.update({
          id: configId,
          data: configuration,
        });
      } catch (error) {
        if (!isNotFoundError(error)) {
          throw error;
        }

        await repository.set({
          id: configId,
          data: configuration,
        });
      }
    },
  });

  return {
    ...mutation,
    saveConfiguration: mutation.mutateAsync,
  };
};
